import { FormControl, Grid, InputLabel, MenuItem, Select, TextField, IconButton, Tooltip, Box, FormControlLabel, Switch } from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useEffect, useState } from "react";

function VirtualForm({fields, data, onChange, onSubmit}){
    const [form, setForm] = useState({});

    const isFieldVisible = (field, values) => {
        if(!field?.showIf){
            return true;
        }

        return Object.keys(field.showIf).every(depKey => {
            const expectedValue = field.showIf[depKey];
            const currentValue = values?.[depKey] !== undefined ? values[depKey] : fields?.[depKey]?.default;
            return currentValue === expectedValue;
        });
    }

    useEffect(() => {
        setForm(data);
    },[data]);

    const _onChange = (field, value) => {
        let nextValue = value;
        if(field && field.type === "number" && value !== ""){
            let numericValue = Number(value);
            if(!isNaN(numericValue)){
                if(field.min !== undefined){
                    numericValue = Math.max(Number(field.min), numericValue);
                }
                if(field.max !== undefined){
                    numericValue = Math.min(Number(field.max), numericValue);
                }
                nextValue = numericValue;
            }
        }

        const _form = {
            ...form,
            [field]: nextValue
        };
        setForm(_form)
        onChange && onChange(_form)
    }

    const renderFieldNote = field => {
        if(!field.note){
            return null;
        }

        return <Tooltip title={field.note} arrow placement="top">
            <IconButton
                size="small"
                aria-label="Field info"
                sx={{mt: 1}}
            >
                <InfoOutlinedIcon fontSize="inherit" />
            </IconButton>
        </Tooltip>
    }

    // console.log(fields);
    const inner = Object.keys(fields).map(fieldId => {
        const field = fields[fieldId];
        const values = form || data || {};

        if(!isFieldVisible(field, values)){
            return null;
        }

        const value = data[fieldId] || field["default"]
        const fieldNote = renderFieldNote(field);

        return <Grid sm={12} item key={fieldId}>
            <Box sx={{display: 'flex', alignItems: 'flex-start', gap: 0.5}}>
                <Box sx={{flexGrow: 1}}>
                    {field.type === "switch" && <FormControlLabel
                        control={<Switch
                            checked={!!value}
                            onChange={e => _onChange(fieldId, e.target.checked)}
                        />}
                        label={field.label}
                    />}

                    {field.type === "select" && <FormControl fullWidth>
                        <InputLabel required={!!field.required}>{field.label}</InputLabel>    
                        <Select
                            fullWidth
                            required={!!field.required}
                            value={value}
                            onChange={e => _onChange(fieldId, e.target.value)}
                        >
                            {Object.keys(field.options).map(oName => {
                                const text = field.options[oName];
                                return <MenuItem key={oName} value={oName}>{text}</MenuItem>
                            })}
                        </Select>
                    </FormControl>}
                    
                    {(!field.type || field.type === "text" || field.type === "textarea" || field.type === "number") && <TextField
                        fullWidth
                        type={field.type || "text"}
                        required={!!field.required}
                        label={field.label}
                        multiline={field.type==="textarea"}
                        rows={field.type==="textarea" ? 3 : 1}
                        value={value}
                        inputProps={field.type === "number" ? {
                            min: field.min,
                            max: field.max,
                            step: field.step || 1
                        } : undefined}
                        onChange={e => _onChange(fieldId, e.target.value)}
                    />}
                </Box>
                {fieldNote}
            </Box>
        </Grid>
    });

    if(onSubmit){
        return <form onSubmit={onSubmit}>
            {inner}
        </form>
    }
    return inner;
}
export default VirtualForm;